var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"its-about-map"},[_c('div',{staticClass:"its-about-address"},[_c('span',{staticClass:"its-position-bg"}),_c('span',{staticClass:"its-position"},[_vm._v(_vm._s(_vm.item.address))]),_c('span',[_vm._v(_vm._s(_vm.item.postalCode))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }